<template>
  <Colleagues>
      <SearchBox
        :placeholder.once="'Type a name or email.'"
        :value.sync="name"
        :search="fetchColleagueSearchResults"/>

      <Loader v-if="fetchingSearchResults" />
      <ul v-else class="mt-2">
        <li v-for="user in results" class="d-flex align-items-center justify-content-between pb-2 pt-2 search-border flex-wrap">
          <div class="d-flex justify-content-between align-items-center mb-1">
            <img :src="user.avatar_url + '&size=48'" class="mr-2 br-1"/>
            <p class="mr-2" :title="user.email">{{ user.name || user.email }}<br />
              <small v-if="user.school">{{ user.school }}</small>
            </p>
          </div>
          <div class="d-flex justify-content-end grow-1">
            <button class="button is-primary" disabled="true" v-if="user.requested">
               &nbsp;&nbsp;&nbsp;Sent&nbsp;&nbsp;&nbsp;
            </button>
            <button class="button is-success" :class="user.loading && 'is-loading'" @click="sendColleagueRequest(user)" v-else>
              Request
            </button>
          </div>
        </li>

        <li v-if="initialState">
          <p class="text-center fs-5 text-muted mt-4">Search for colleagues in your group.</p>
        </li>
        <li v-else-if="results.length === 0" class="text-center bold fs-5 text-muted">
          No results found.
        </li>
      </ul>
  </Colleagues>
</template>

<script>
import Colleagues from './Colleagues'
import SearchBox from './SearchBox'
import Loader from './Loader.vue'

import axios from 'axios'
import store from '../store'
import { focus } from '../directives.js'

import { generalErrorHandler } from '../actionTypes'

export default {
  name: 'FindColleaguesModal',
  components: {
    Loader,
    Colleagues,
    SearchBox,
  },
  computed: {
  },
  data () {
    return {
      results: [],
      name: '',
      initialState: true,
      fetchingSearchResults: false
    }
  },
  directives: {
    focus,
  },
  methods: {
    close () {
      this.results = []
      this.$emit('close')
    },
    fetchColleagueSearchResults (val) {
      if (val) { this.name = val }
      if (this.fetchingSearchResults) { return }
      this.initialState = false
      this.fetchingSearchResults = true
      return axios.get('/api/v1/colleagues/?search=' + this.name,
        { headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } })
      .then(response => {
        // We set the field 'loading' on the models so Vue can watch them
        response.data.forEach(function (x) { x.loading = false })
        this.results = response.data

        this.fetchingSearchResults = false
      })
      .catch(error => {
        this.fetchingSearchResults = false
        store.dispatch(generalErrorHandler, {
          error,
          message: "Oops, we couldn't make that search."
        })
      })
    },
    isLoading (user) {
      const userModel = this.results[this.results.find(x => x.id === user.id)]
      return userModel && userModel.loading
    },
    sendColleagueRequest (colleague) {
      this.results[this.results.findIndex(x => x.id === colleague.id)].loading = true
      store.dispatch('sendColleagueRequest', { colleague })
        .then(() => {
          const user = this.results[this.results.findIndex(x => x.id === colleague.id)]
          user.loading = false
          user.requested = true
        })
    },
  },
}

</script>

<style lang="scss" scoped>

.modal-card-body {
  min-height: 150px;
  max-height: 800px;
  overflow: initial;
  overflow-y: scroll;
}

.search-border {
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-bottom-color: lightgray;
    &:last-child {
      border-bottom: none;
    }
}
</style>



// WEBPACK FOOTER //
// FindColleagues.vue?9e1a7e86